'use client'

import { useEffect } from 'react'
import { usePathname } from '@repo/shared/i18n/navigation'
interface ScrollResetOptions {
  behavior?: ScrollBehavior
  smooth?: boolean
}

export const useScrollReset = (options: ScrollResetOptions = {}) => {
  const pathname = usePathname()
  const { behavior = 'smooth', smooth = true } = options

  useEffect(() => {
    // Reset scroll to top when pathname changes
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: smooth ? 'smooth' : 'auto',
      })
    }, 500)
  }, [pathname, behavior, smooth])
}

export const useScrollToTop = () => {
  const pathname = usePathname()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
}
